import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { BackButton } from '../components/BackButton';
import { paths } from '../navigation/paths';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const { username, setUsername, password, setPassword, handleAdminLogin } = useApp();

  return (
    <div className="login-screen">
      <nav className="sticky-nav">
        <div className="nav-brand">
          <span className="nav-icon">🐉</span>
          <span className="nav-title">Ralfs Abenteuer</span>
        </div>
        <div className="nav-buttons">
          <button className="nav-btn player-btn" aria-label="Spieler" type="button" onClick={() => navigate(paths.play)}>
            <span className="btn-icon" aria-hidden>⚔️</span>
            <span className="btn-label">Spieler</span>
          </button>
          <button className="nav-btn admin-btn active" aria-label="Spielleiter" type="button" onClick={() => navigate(paths.login)}>
            <span className="btn-icon" aria-hidden>👑</span>
            <span className="btn-label">Spielleiter</span>
          </button>
        </div>
      </nav>
    <div className="admin-login medieval">
      <div className="login-container">
        <div className="ornament-top">👑</div>
        <h1>Spielleiter Anmeldung</h1>
        <p className="login-subtitle">Nur für den Meister des Spiels</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAdminLogin(username, password);
            setUsername('');
            setPassword('');
          }}
        >
          <div className="form-group">
            <label htmlFor="admin-username">Benutzername</label>
            <input
              id="admin-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="admin-password">Passwort</label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
              required
            />
          </div>
          <button type="submit" className="medieval-button">Eintreten</button>
        </form>
        <BackButton fallback={paths.landing} className="medieval-button back-button-admin">
          ← Zurück<span className="btn-extra"> zur Startseite</span>
        </BackButton>
      </div>
    </div>
    </div>
  );
}
